import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormArray, FormGroup, AbstractControl, FormBuilder } from '@angular/forms';
import { Observable, throwError, merge, EMPTY, Subject,of } from 'rxjs';
import { map, distinct, mapTo, catchError, retry, filter } from 'rxjs/operators';

import * as constants from "@app/shared/constants";
import days from "dayjs";

import { environment } from '@app/../environments/environment';
import { LoginService } from '@app/common/login.service';
import { Event } from '@app/shared/_models/common';
import { Sales_order } from '@app/shared/_models/sales';

@Injectable({
	providedIn: 'root'
})
export class PaymentService {

	constructor(public loginService: LoginService, private http: HttpClient) { }
	public subject = new Subject<any>();

		

  postPaymentEvent(eventtyp: number, formGroup: FormGroup): Observable<any> {
    console.log("[postPaymentEvent] user: ", this.loginService.loggeduser);
    // this.beforeSubmit(formGroup);	// Do some type adjustements
    let isodate = days(new Date(formGroup.get('dat')?.value)).format(constants.iso8601formatTime);
    formGroup.get('dat')?.patchValue(isodate);
    let event: Event = {
      id: 0,
      typ: eventtyp,			// 1: Insert, 2: Update, 3: Delete
      userid: this.loginService.loggeduser?.id,
      objectid: formGroup.get('id')?.value,
      objecttyp: constants.ObjectType.PAYMENT,		// Payment
      data: formGroup.value,
    }
    return this.http.post<any>(environment.server_url + "/event", event, { 'headers': constants.jsonheader });
  }


}
